module.exports = __webpack_public_path__ + "media/images/home/screen_1-399eca52f1371f1b4809ac9b064f425c.png";